import Vue from 'vue';
import { getProfile } from '../../../services/personnelService/qrCodeService';
// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name

const state = {
    saData: null,
    TRList: [
        '10K',
        'Clienteling',
        'CORE',
        'INACTIVE',
        'Lapsed',
        'LOW',
        'MID',
        'NEAR 10K',
        'VIC',
        'VVIC',
    ],
    genderList: ['Female', 'Male', 'Other', 'Unknown']
};

// getters
const getters = {};

// actions
const actions = {
    // 經銷商列表
    async getSaProfileHandler({ commit }) {
        const data = await getProfile();
        commit('setSaData', data.data);
        return data;
    }
};

// mutations
const mutations = {
    setSaData(state, data) {
        Vue.set(state, 'saData', data.personnel);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
